export default {
    platformName: '彩票管理系统',
    version: '1.0.0',
    author: '欧阳小白 ( telegram: @liuxiaobai )',
    telegram: 'https://t.me/liuxiaobai'

  };